import { render, staticRenderFns } from "./now.vue?vue&type=template&id=5c30df58"
import script from "./now.vue?vue&type=script&lang=js"
export * from "./now.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BuyPrice: require('/usr/src/app/components/buy/price.vue').default,TfFrame: require('/usr/src/app/components/tf/frame.vue').default})
